import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class ContractsAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      client_id: null,
      aircraft_id: null,
      base_id: null,
      name: null,
      management: null,
      noturno: 0,
      carga_externa: 0,
      comissarios: 0,
      age_filter: null,
      age_filter_maximum: null,
      backup_aircraft_id: null,
      availability: null,
      date_start: null,
      consumption: null,
      payment_type: null,
      due_date: null,
      availability_time: null,
      interruption_time: null,
      interruption_start: null,
      spare_time: null,
      charter: null,
      xml: null,
      type: null,
      expire: null,
      bases_list: [],
      aircrafts_list: [],
      clients_list: [],
      errors_messages: [],
      errors_listing: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/aeronaves/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({aircrafts_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/bases/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({bases_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/clientes/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({clients_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */ }); /* Lista de bases */ }); /* Lista de clientes */
    });
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      client_id: this.state.client_id,
      aircraft_id: this.state.aircraft_id,
      base_id: this.state.base_id,
      name: this.state.name,
      management: this.state.management,
      type: this.state.type,
      expire: this.state.expire,
      noturno: this.state.noturno,
      carga_externa: this.state.carga_externa,
      comissarios: this.state.comissarios,
      age_filter: this.state.age_filter,
      age_filter_maximum: this.state.age_filter_maximum,
      backup_aircraft_id: this.state.backup_aircraft_id,
      availability: this.state.availability,
      date_start: this.state.date_start,
      consumption: this.state.consumption,
      payment_type: this.state.payment_type,
      due_date: this.state.due_date,
      availability_time: this.state.availability_time,
      interruption_time: this.state.interruption_time,
      interruption_start: this.state.interruption_start,
      spare_time: this.state.spare_time,
      charter: this.state.charter,
      xml: this.state.xml,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/contrato', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/contrato/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({
            redirect_url: url,
            errors_listing: false,
            errors_messages: [],
          });
        } else if(responseJson.status === 'warning') {
          self.setState({
            errors_listing: true,
            errors_messages: responseJson.data,
          });
        } else {
          self.setState({
            errors_listing: false,
            errors_messages: [],
          });
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Contratos.AdicionarContrato.titulo}</h3>
      <Link to="/contratos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      {this.state.errors_listing &&
        <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
          <button onClick={() => self.setState({ errors_listing: false, errors_messages: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>{this.locale.Contratos.AdicionarContrato.erros}:</strong>
          {Object.keys(self.state.errors_messages).map(function(k) {
            var message = self.state.errors_messages[k];
            return (
              <p>- {message}</p>
            );
          })}
        </div>
      }      
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Contratos.AdicionarContrato.formulario.Cliente}:</label>
              <Select
                className="form-field-name"
                name="client_id"
                value={this.state.client_id}
                searchable={true}
                placeholder={this.locale.Contratos.AdicionarContrato.formulario.placeholder.SelecionarCliente}
                onChange={this.handleSelectChange.bind(this, 'client_id')}
                options={this.state.clients_list}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Contratos.AdicionarContrato.formulario.Aeronave}:</label>
              <Select
                className="form-field-name"
                name="aircraft_id"
                value={this.state.aircraft_id}
                searchable={true}
                placeholder={this.locale.Contratos.AdicionarContrato.formulario.placeholder.SelecionarAeronave}
                onChange={this.handleSelectChange.bind(this, 'aircraft_id')}
                options={this.state.aircrafts_list}
                required
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Contratos.AdicionarContrato.formulario.Tipo}:</label>
              <Select
                className="form-field-name"
                name="type"
                value={this.state.type}
                searchable={true}
                placeholder={this.locale.Contratos.AdicionarContrato.formulario.placeholder.SelecionarTipo}
                onChange={this.handleSelectChange.bind(this, 'type')}
                options={[
                  {value: "normal", label: this.locale.Contratos.AdicionarContrato.formulario.opcoesTipo.TripulacaoRegular},
                  {value: "noturno", label: this.locale.Contratos.AdicionarContrato.formulario.opcoesTipo.TripulacaoNoturna},
                  {value: "medvac", label: this.locale.Contratos.AdicionarContrato.formulario.opcoesTipo.TripulacaoMEDVAC},
                  {value: "normal_comissarios", label: this.locale.Contratos.AdicionarContrato.formulario.opcoesTipo.TripulacaoRegularComComissarios},
                  {value: "noturno_comissarios", label: this.locale.Contratos.AdicionarContrato.formulario.opcoesTipo.TripulacaoNoturnaComComissarios},
                  {value: "medvac_comissarios", label: this.locale.Contratos.AdicionarContrato.formulario.opcoesTipo.TripulacaoMEDVACComComissarios},
                ]}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Contratos.AdicionarContrato.formulario.NumDeContrato}:</label>
              <input type="text" name="name" className="form-control" placeholder={this.locale.Contratos.AdicionarContrato.formulario.placeholder.NumeroDeContrato} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Contratos.AdicionarContrato.formulario.Gerencia}:</label>
              <input type="text" name="management" className="form-control" placeholder={this.locale.Contratos.AdicionarContrato.formulario.placeholder.Gerencia} value={this.state.management} onChange={this.handleChange.bind(this, 'management')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Contratos.AdicionarContrato.formulario.IdadeMinimaEmAnos}:</label>
              <input type="number" name="age_filter" className="form-control" placeholder={this.locale.Contratos.AdicionarContrato.formulario.placeholder.IdadeMinimaEmAnos} value={this.state.age_filter} onChange={this.handleChange.bind(this, 'age_filter')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Contratos.AdicionarContrato.formulario.IdadeMaximaEmAnos}:</label>
              <input type="text" name="age_filter_maximum" className="form-control" placeholder={this.locale.Contratos.AdicionarContrato.formulario.placeholder.IdadeMaximaEmAnos} value={this.state.age_filter_maximum} onChange={this.handleChange.bind(this, 'age_filter_maximum')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Contratos.AdicionarContrato.formulario.Inicio}:</label>
              <InputMask value={this.state.date_start}  maskChar={null} name="date_start " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder={this.locale.Contratos.AdicionarContrato.formulario.placeholder.DataDeInicio} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Contratos.AdicionarContrato.formulario.Termino}:</label>
              <InputMask value={this.state.expire}  maskChar={null} name="expire " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'expire')} placeholder={this.locale.Contratos.AdicionarContrato.formulario.placeholder.DataDeTermino} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Contratos.AdicionarContrato.formulario.DiaFixoDeVencimento}:</label>
              <InputMask value={this.state.due_date}  maskChar={null} name="due_date " mask="99" className="form-control" onChange={this.handleChange.bind(this, 'due_date')} placeholder={this.locale.Contratos.AdicionarContrato.formulario.placeholder.DiaFixoDeVencimento} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Contratos.AdicionarContrato.formulario.TipoDePagamento}:</label>
              <Select
                className="form-field-name"
                name="payment_type"
                value={this.state.payment_type}
                searchable={true}
                placeholder={this.locale.Contratos.AdicionarContrato.formulario.placeholder.TipoDePagamento}
                onChange={this.handleSelectChange.bind(this, 'payment_type')}
                options={[
                  {value: 'Partida ao Corte', label: this.locale.Contratos.AdicionarContrato.formulario.opcoesTipoDePagamento.PartidaAoCorte},
                  {value: 'Decolagem ao Pouso', label: this.locale.Contratos.AdicionarContrato.formulario.opcoesTipoDePagamento.DecolagemAoPouso}
                ]}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Contratos.AdicionarContrato.formulario.Consumo}:</label>
              <input value={this.state.consumption} name="consumption" className="form-control" onChange={this.handleChange.bind(this, 'consumption')} placeholder={this.locale.Contratos.AdicionarContrato.formulario.placeholder.Consumo} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Contratos.AdicionarContrato.formulario.TempoDeDisponibilidade}:</label>
              <InputMask value={this.state.availability} name="availability " mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'availability')} placeholder={this.locale.Contratos.AdicionarContrato.formulario.placeholder.Disponibilidade} required />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Contratos.AdicionarContrato.formulario.HoraInicialDaDisponibilidade}:</label>
              <InputMask value={this.state.availability_time}  maskChar={null} name="availability_time " mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'availability_time')} placeholder={this.locale.Contratos.AdicionarContrato.formulario.placeholder.HoraInicialDaDisponibilidade} required />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Contratos.AdicionarContrato.formulario.BaseContratual}:</label>
            <Select
              className="form-field-name"
              name="base_id"
              value={this.state.base_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'base_id')}
              options={this.state.bases_list}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Contratos.AdicionarContrato.formulario.XML}:</label>
              <br/>
              <Toggle
                checked={this.state.xml}
                aria-label='No label tag'
                name="xml"
                onChange={this.handleToggleChange.bind(this, 'xml')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Contratos.AdicionarContrato.formulario.Noturno}:</label>
              <br/>
              <Toggle
                checked={this.state.noturno}
                aria-label='No label tag'
                name="noturno"
                onChange={this.handleToggleChange.bind(this, 'noturno')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Contratos.AdicionarContrato.formulario.CargaExterna}:</label>
              <br/>
              <Toggle
                checked={this.state.carga_externa}
                aria-label='No label tag'
                name="carga_externa"
                onChange={this.handleToggleChange.bind(this, 'carga_externa')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Contratos.AdicionarContrato.formulario.Comissarios}:</label>
              <br/>
              <Toggle
                checked={this.state.comissarios}
                aria-label='No label tag'
                name="comissarios"
                onChange={this.handleToggleChange.bind(this, 'comissarios')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Contratos.AdicionarContrato.formulario.Fretamento}:</label>
              <br/>
              <Toggle
                checked={this.state.charter}
                aria-label='No label tag'
                name="charter"
                onChange={this.handleToggleChange.bind(this, 'charter')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Contratos.AdicionarContrato.formulario.botaoAdicionarContrato}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default ContractsAdd;



// WEBPACK FOOTER //
// ./src/Components/Contracts/ContractsAdd.js